import { defineMessages } from 'react-intl';

export const i18n: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	suggestedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'search-page-relay.filters.product-filters.workspace-name.label',
		defaultMessage: 'Team',
		description: 'Label for the Microsoft Teams team (workspace) filter dropdown',
	},
	placeholder: {
		id: 'search-page-relay.filters.product-filters.workspace-name.placeholder',
		defaultMessage: 'Filter by team',
		description: 'Placeholder text for the Microsoft Teams team filter search input',
	},
	selectedLabel: {
		id: 'search-page-relay.filters.product-filters.workspace-name.selected-label',
		defaultMessage: 'Selected',
		description: 'Group label for selected teams in the dropdown',
	},
	suggestedLabel: {
		id: 'search-page-relay.filters.product-filters.workspace-name.suggested-label',
		defaultMessage: 'Teams',
		description: 'Group label for suggested teams in the dropdown',
	},
});
